export * from './tokens';
export * from './components/Icon';
export * from './components/Cup';
export * from './components/primitives';
export * from './components/layout';
export * from './components/logo';
export * from './components/nav';
export * from './components/LayoutPicker';
export * from './screenSize';
export * from './navigation';
export * from './session';
export * from './data';
export * from './pwa';
export * from './sound';
export { formatVnd, formatVndCompact } from '@khaddi/contracts';

/** `HH:mm` in store time for an ISO timestamp. */
export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Ho_Chi_Minh' });

/** "Hôm nay, 11:17" / "18/10, 16:05". */
export const formatDateTime = (iso: string): string => {
  const date = new Date(iso);
  const day = date.toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', timeZone: 'Asia/Ho_Chi_Minh' });
  const today = new Date().toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', timeZone: 'Asia/Ho_Chi_Minh' });
  return `${day === today ? 'Hôm nay' : day}, ${formatTime(iso)}`;
};

export const formatKm = (km: number): string => `${km.toLocaleString('vi-VN', { maximumFractionDigits: 1 })} km`;
